import { Text, TextSize, TokenIcon } from '@rhinofi/dvf-shared-ui'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { findBridgeKeyForNetworkId } from '../../../services/helperService/findBridgeKeyForNetworkId'
import { shortenAddress } from '../../../services/helperService/shortenAddress'
import { selectAddress, selectConnectedNetwork } from '../../../store/selectors/user.selectors'
import { FlexContainer } from '../../common/Wrappers/Containers'
import { useIsMobile } from '../../../hooks/useIsMobile'
import { selectConfig } from '../../../store/selectors/portal.selectors'

export const EVMConnected = () => {
  const address = useAppSelector(selectAddress)
  const network = useAppSelector(selectConnectedNetwork)
  const bridgeConfig = useAppSelector(selectConfig)
  const { isMobile } = useIsMobile()

  const chainID = findBridgeKeyForNetworkId(network?.toString() || '', bridgeConfig || {}) || ''

  return (
    <FlexContainer $gap="8px" className="high-priority-display">
      <TokenIcon token={chainID} customSize="20px" />
      <Text size={TextSize.S} data-testid="evm-address-menu">
        {shortenAddress(address, isMobile, isMobile ? 6 : 5)}
      </Text>
    </FlexContainer>
  )
}
